import { Camera } from "lucide-react";
import gallery from "../data/gallery.json";

// Slot foto sostituibile: finché gallery.json ha src null mostra il segnaposto «Foto in arrivo».
// In fase 2 basta caricare il file in /images e compilare src/alt in gallery.json.
export const PhotoSlot = ({
    slotId,
    icon: Icon = Camera,
    fill = false,
    ratio = "aspect-[4/3]",
    eager = false,
    caption = true,
    className = "",
}) => {
    const entry = gallery.slots?.[slotId];
    if (entry?.src) {
        return (
            <img
                src={entry.src}
                alt={entry.alt || ""}
                loading={eager ? "eager" : "lazy"}
                className={`w-full h-full object-cover ${className}`}
                data-testid={`photo-${slotId}`}
            />
        );
    }
    return (
        <div
            className={`${fill ? "w-full h-full" : ratio} placeholder-foto ${className}`}
            data-testid={`photo-slot-${slotId}`}
            role="img"
            aria-label="Foto in arrivo: immagine non ancora disponibile"
        >
            <Icon className="w-8 h-8" strokeWidth={1.25} />
            {caption && <span>Foto in arrivo</span>}
        </div>
    );
};